<template>
  <div class="releaseWrapper">
    <div class="padding-tb-24 top">
      <div class="container">
        <h4>Engagement Tool Loan</h4>
      </div>
    </div>
    <!--end of top-->
    <div class="mid">
      <div class="container padding-tb-24">
        <mds-layout-grid>
          <mds-row>
            <mds-col :cols="12" :cols-at-s="6">
              <div class="label"></div>
              <h2>Engagement Tools</h2>
              <div class="padding-tb-16">
                <p>
                  Congrartulations! You'r one of the few selected users having
                  access to this beta version of the engagement tools.
                </p>
                <p class="padding-tb-24">
                  The puprpose of beta teating is to get feedback from valuable
                  clinets lke yourself so that we can supercharge your cashflow
                  modelling experience better and faster.
                </p>
                <p>
                  We are here to learn any quetions or feedback please contact
                  xxx@morningstar.com
                </p>
                <div class="padding-tb-16">
                  <mds-button
                    variation="primary"
                    size="large"
                    @click="toggle = !toggle"
                  >
                    Get Started
                  </mds-button>
                </div>
              </div>
            </mds-col>
            <mds-col :cols="12" :cols-at-s="6">
              <div class="release-img-wrap">
                <img
                  src="../assets/Wealth-Bucketing_Intro.png"
                  alt="intor-beta"
                />
              </div>
            </mds-col>
          </mds-row>
        </mds-layout-grid>
      </div>
    </div>
    <!-- end of mid-->

    <mds-dialog
      v-model="toggle"
      action-required
      title="Disclaimer"
      width="500px"
    >
      Lorem Ipsum is simply dummy text of the printing and typesetting industry.
      Lorem Ipsum has been the industry's standard dummy text ever since the
      1500s, when an unknown printer took a galley of type and scrambled it to
      make a type specimen book. It has survived not only five centuries, but
      also the leap into electronic typesetting, remaining essentially
      unchanged. It was popularised in the 1960s with the release of Letraset
      sheets containing Lorem Ipsum passages, and more recently with desktop
      publishing software like Aldus PageMaker including versions of Lorem
      Ipsum.

      <template #mds-dialog-supplemental-content>
        <mds-checkbox v-model="IsAgree" ref="agreeCheckbox"
          >I have read and understood that this is the beta version for testing
          puprpose only.</mds-checkbox
        >
      </template>
      <template #mds-dialog-actions-right>
        <mds-button-container right-aligned>
          <mds-button
            type="button"
            variation="secondary"
            @click="toggle = !toggle"
          >
            Cancel
          </mds-button>
          <mds-button type="button" variation="primary" @click="confirm()">
            Next
          </mds-button>
        </mds-button-container>
      </template>
    </mds-dialog>
  </div>
</template>

<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsDialog from "@mds/dialog";
import MdsCheckbox from "@mds/checkbox";
export default {
  name: "cf-release-info",
  components: {
    MdsButton,
    MdsButtonContainer,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsDialog,
    MdsCheckbox,
  },
  data() {
    return {
      toggle: false,
      IsAgree: false,
    };
  },
  methods: {
    confirm() {
      if (this.IsAgree) {
        this.$emit("confirm");
      } else {
        this.$refs.agreeCheckbox.$el.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  border-bottom: $mds-border-separator;
}
.release-img-wrap {
  img {
    max-width: 584px;
    max-height: 723px;
    width: 100%;
  }
}
.label {
  @include mds-eyebrow-heading();
  @include padding-tb($mds-space-1-x);
}
.mds-layout-grid___CashFlow {
  @include v-center();
}
</style>
